angular.module('impactx.invoice').controller('InvoiceAddOrderCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'actionLabel',
    'withOrderRefLabel',
    'noOrderRefLabel',
    'orderLabel',
    'forwardLabel',
    'abortLabel',
    'confirmLabel',
    'requiredLabel',
    'noSelectedItemMessage',
    'lotSupplierId',
    'cscId',
    'excludePOHIds',
    InvoiceAddOrderCtrl]);

function InvoiceAddOrderCtrl($scope, $mdDialog, themeFactory, dataGen, actionLabel, withOrderRefLabel, noOrderRefLabel, orderLabel,
                             forwardLabel, abortLabel, confirmLabel, requiredLabel, noSelectedItemMessage, lotSupplierId, cscId, excludePOHIds)
{
    var ctrl = this;
    $scope.canFinish = {};
    $scope.canFinish.value = false;
    $scope.selectedCreationType = {};
    $scope.selectedCreationType.value = 1;
    $scope.actionLabel = actionLabel;
    $scope.withOrderRefLabel = withOrderRefLabel;
    $scope.noOrderRefLabel = noOrderRefLabel;
    $scope.orderLabel = orderLabel;
    $scope.forwardLabel = forwardLabel;
    $scope.abortLabel = abortLabel;
    $scope.confirmLabel = confirmLabel;
    $scope.requiredLabel = requiredLabel;
    $scope.noSelectedItemMessage = noSelectedItemMessage;
    $scope.theme = themeFactory.getTheme();
    $scope.lotSupplier = {};
    $scope.lotSupplier.selected = null;
    $scope.orderCompany = {};
    $scope.orderCompany.selected = null;
    $scope.order = {};
    $scope.order.selected = null;
    $scope.wizardIndex = 0;
    $scope.showMust = true;
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.forward = function ()
    {
        if ($scope.wizardIndex == 0)
        {
            if ($scope.selectedCreationType.value == 2)
            {
                ctrl.finish();
            }
            else
            {
                $scope.wizardIndex++;
            }
        }
        else if ($scope.wizardIndex == 1)
        {
            ctrl.finish();
        }
    };
    this.finish = function ()
    {
        $mdDialog.hide({
            pohId: $scope.order.selected && $scope.order.selected.id ? $scope.order.selected.id : 0,
            withOrderRelation: $scope.selectedCreationType.value == 1
        });
    };
    this.getOrderEntries = function(searchText)
    {
        return dataGen.getData({}, {searchText: searchText, lotSupplierId: lotSupplierId,
            cscId: cscId, excludePOHIds: excludePOHIds}, "/invoice/orders", null, true).then(function(data) {
                return data.data.entries;
        });
    };
}